/**
 * @generated SignedSource<<c8387b882d3435676c14c949ef15aace>>
 * @relayHash 197595cb76d03c058f5fbb845dc266a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 89a76fcc88ae0753908f2aaff4b8debcf7a025d460506fe67d47266e32c2ec9b

import type { ConcreteRequest } from 'relay-runtime';
export type SpaceViewsPersistenceOption = "POPULARITY" | "RECENTLY_MODIFIED" | "RECENTLY_VIEWED" | "TITLE_AZ" | "TREE" | "%future added value";
export type useSpaceViewsOptionsSpaceViewsPersistenceMutation$variables = {
  persistenceOption: SpaceViewsPersistenceOption;
  spaceKey: string;
};
export type useSpaceViewsOptionsSpaceViewsPersistenceMutation$data = {
  readonly updateUserPreferences: {
    readonly spaceViewsPersistence: SpaceViewsPersistenceOption;
  } | null | undefined;
};
export type useSpaceViewsOptionsSpaceViewsPersistenceMutation = {
  response: useSpaceViewsOptionsSpaceViewsPersistenceMutation$data;
  variables: useSpaceViewsOptionsSpaceViewsPersistenceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "persistenceOption"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = {
  "kind": "Variable",
  "name": "spaceKey",
  "variableName": "spaceKey"
},
v3 = [
  {
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "persistenceOption",
                "variableName": "persistenceOption"
              },
              (v2/*: any*/)
            ],
            "kind": "ObjectValue",
            "name": "spaceViewsPersistence"
          }
        ],
        "kind": "ObjectValue",
        "name": "userPreferences"
      }
    ],
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "updateUserPreferences",
    "plural": false,
    "selections": [
      {
        "args": [
          (v2/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "spaceViewsPersistence"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "197595cb76d03c058f5fbb845dc266a1",
    "id": "89a76fcc88ae0753908f2aaff4b8debcf7a025d460506fe67d47266e32c2ec9b",
    "metadata": {},
    "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
    "operationKind": "mutation",
    "text": "mutation useSpaceViewsOptionsSpaceViewsPersistenceMutation($spaceKey:String!,$persistenceOption:SpaceViewsPersistenceOption!){updateUserPreferences(userPreferences:{spaceViewsPersistence:{spaceKey:$spaceKey,persistenceOption:$persistenceOption}}){spaceViewsPersistence(spaceKey:$spaceKey)}}"
  }
};
})();

(node as any).hash = "c904b4b947ce0e659a2538aaffec18be";

export default node;
